import axios from "axios";

export const API_BASE = String(
  process.env.REACT_APP_API_BASE || "https://globizsystems.click"
).trim().replace(/\/+$/, "");

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

export function setAuthToken(token) {
  if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete api.defaults.headers.common.Authorization;
}

setAuthToken(localStorage.getItem("admin-mobile-token"));

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin-mobile-token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function adminGetAgents() {
  const res = await api.get("/api/admin/agents");
  return res.data;
}

export async function adminCreateAgent(payload) {
  const res = await api.post("/api/admin/agents", payload);
  return res.data;
}

export async function adminUpdateAgent(agentId, payload) {
  const res = await api.patch(`/api/admin/agents/${agentId}`, payload);
  return res.data;
}

export async function adminGetAgentUnits(agentId, template = "") {
  const res = await api.get(`/api/admin/agents/${agentId}/units`, {
    params: template ? { template } : {},
  });
  return res.data;
}

export async function adminSetAgentUnits(agentId, payload) {
  const res = await api.put(`/api/admin/agents/${agentId}/units`, payload);
  return res.data;
}

export async function adminListCustomers(params = {}) {
  const res = await api.get("/api/admin/sewa/customers", { params });
  return res.data;
}

export async function adminUploadBills(formData) {
  const res = await api.post("/api/admin/sewa/bills/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function adminUploadCustomers(template, formData) {
  const res = await api.post(`/api/admin/sewa/upload/${template}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function adminUploadCompleteSewaData(template, formData) {
  const res = await api.post(`/api/admin/sewa/upload/${template}/complete`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}


export async function adminDashboardSummary() {
  const res = await api.get("/api/admin/sewa/dashboard-summary");
  return res.data;
}

export async function adminListZones(template = "perumahan") {
  const res = await api.get("/api/admin/sewa/zones", {
    params: { template },
  });
  return res.data;
}

export async function adminListZoneCustomers(zoneId, template = "perumahan", search = "") {
  const res = await api.get(`/api/admin/sewa/zones/${encodeURIComponent(zoneId)}/customers`, {
    params: { template, search },
  });
  return res.data;
}

export async function adminMonthlyChargeReport(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/charges/monthly", {
    params,
  });
  return res.data;
}

export async function adminPaymentReportDaily(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/payments/daily", { params });
  return res.data;
}

export async function adminPaymentReportWeekly(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/payments/weekly", { params });
  return res.data;
}

export async function adminPaymentReportMonthly(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/payments/monthly", { params });
  return res.data;
}

export async function adminArrearsReportWeekly(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/arrears/weekly", { params });
  return res.data;
}

export async function adminArrearsReportMonthly(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/arrears/monthly", { params });
  return res.data;
}

export async function adminDbklMonthlyReport(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/dbkl/monthly", {
    params,
  });
  return res.data;
}

export async function adminAgentKpiRanking(params = {}) {
  const res = await api.get("/api/admin/sewa/reports/kpi-agents", { params });
  return res.data;
}

export async function adminListReviews(params = {}) {
  const res = await api.get("/api/admin/sewa/reviews", { params });
  return res.data;
}

export async function adminReviewSubmission(remarkId, payload) {
  const res = await api.patch(`/api/admin/sewa/reviews/${remarkId}`, payload);
  return res.data;
}

export async function adminMarkReviewRead(remarkId) {
  const res = await api.patch(`/api/admin/sewa/reviews/${remarkId}/read`);
  return res.data;
}

export async function adminDeleteAgent(agentId) {
  const res = await api.delete(`/api/admin/agents/${agentId}`);
  return res.data;
}
